<div class="vw-popup-backdrop" (click)="!isLoading && onClose()" @opacityInOut></div>

<div
  class="vw-popup"
  cdkTrapFocus
  @scaleInOut
  role="dialog"
  aria-modal="true"
>
  <div class="vw-popup__header">
    <div class="vw-popup__title-row">
      <div class="vw-popup__icon">
        <i class="app-ico app-ico__attention"></i>
      </div>
      <h2 class="vw-popup__title">{{ props.submitLabel }}</h2>
    </div>
    
    <button
      type="button"
      class="vw-popup__close"
      [disabled]="isLoading"
      (click)="onClose()"
      [attr.aria-label]="'Common.Close' | translate"
    >
      <i class="app-ico-mask app-ico-mask__x"></i>
    </button>
  </div>

  <div class="vw-popup__body">

    <div class="vw-popup__vacancy-info">
      <p class="vw-popup__vacancy-desc">
        {{ 'PositionCreate.YouAreAboutTo' | translate }} {{ props.submitLabel | lowercase }} <strong>{{ props.vacancyTitle }}</strong><span style="display: inline-block;" *ngIf="props.jobId">&nbsp;({{ 'PositionCreate.JobId' | translate }}: {{ props.jobId }})</span>.
      </p>
    </div>

    <div class="vw-popup__warning-alert">
      <p class="vw-popup__message">{{ props.warningMessage }}</p>
    </div>
  </div>

  <div class="vw-popup__footer">
    <button
      type="button"
      class="vw-popup__btn vw-popup__btn--secondary"
      cdkFocusInitial
      [disabled]="isLoading"
      [class.is-disabled]="isLoading"
      (click)="onCancel()"
    >
      {{ props.cancelLabel }}
    </button>
    <button
      type="button"
      class="vw-popup__btn vw-popup__btn--primary"
      [disabled]="isLoading"
      [class.is-disabled]="isLoading"
      [class.is-loading]="isLoading"
      (click)="onSubmit()"
    >
      <ng-container *ngIf="isLoading; else submitText">
        <span class="main-loader"></span>
        {{ props.loadingLabel || ("Common.Loading" | translate) }}
      </ng-container>
      <ng-template #submitText>
        {{ props.submitLabel }}
      </ng-template>
    </button>
  </div>
</div>
